import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const stats = [
  { icon: 'ri-time-line', value: '24/7', label: 'Atención permanente' },
  { icon: 'ri-hospital-line', value: '+15', label: 'Especialidades médicas' },
  { icon: 'ri-calendar-2-line', value: '+8', label: 'Años de servicio' },
  { icon: 'ri-user-heart-line', value: '+5000', label: 'Pacientes atendidos' },
];

export default function StatsBar() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="relative px-4 md:px-8 lg:px-12 -mt-2 bg-background-100">
      <div className="max-w-6xl mx-auto py-10 md:py-16">
        <div
          ref={ref}
          className={`relative rounded-3xl bg-secondary-950 overflow-hidden reveal ${isVisible ? 'is-in' : ''}`}
        >
          <div className="absolute inset-0 texture-dots-light opacity-40" />
          <div className="absolute -top-16 -right-10 w-56 h-56 rounded-full bg-primary-600/30 blur-3xl" />
          <div className="absolute -bottom-16 left-10 w-56 h-56 rounded-full bg-accent-500/20 blur-3xl" />

          <div className="relative grid grid-cols-2 lg:grid-cols-4 gap-y-8 gap-x-4 p-8 md:p-12">
            {stats.map((stat, i) => (
              <div
                key={stat.label}
                className={`text-center lg:text-left lg:pl-6 ${i > 0 ? 'lg:border-l lg:border-background-50/10' : ''}`}
              >
                <div className="w-11 h-11 mx-auto lg:mx-0 flex items-center justify-center rounded-xl bg-background-50/10 text-accent-500 mb-3">
                  <i className={`${stat.icon} text-xl`} />
                </div>
                <div className="font-heading text-3xl md:text-4xl font-bold text-background-50 leading-none">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-background-300 mt-2">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}